export default "__VITE_ASSET__Bbi5KhA9__"